import styled from 'styled-components';

/**
 * @related ['Highlighter']
 * @since 8.28.0
 */
var Highlight = /*#__PURE__*/styled.mark.withConfig({
  displayName: "Highlight",
  componentId: "c11n-8-107-0__sc-1dgp7ml-0"
})([""]);
Highlight.displayName = 'Highlight';

/** @component */
export { Highlight };